/**
 * Utility to export data arrays to Excel-compatible CSV files.
 * Uses a UTF-8 Byte Order Mark (BOM) so Microsoft Excel on Windows/Mac
 * opens the file directly with correct column separation and special characters (like ñ, á, é, í, ó, ú).
 */
export const exportToExcel = (
  data: any[],
  headers: string[],
  keys: string[],
  filename: string
): void => {
  // \uFEFF is the UTF-8 Byte Order Mark (BOM)
  let csvContent = '\uFEFF';
  
  // Add header row
  csvContent += headers.map(h => `"${String(h).replace(/"/g, '""')}"`).join(',') + '\n';
  
  // Add data rows
  data.forEach(item => {
    const row = keys.map(key => {
      let val = item;
      
      // Support nested keys (e.g., 'enrollment.user.email')
      if (key.includes('.')) {
        const parts = key.split('.');
        for (const part of parts) {
          val = val ? val[part] : '';
        }
      } else {
        val = val[key];
      }
      
      if (val === null || val === undefined) {
        return '""';
      }
      
      if (typeof val === 'object') {
        val = JSON.stringify(val);
      }
      
      // Escape double quotes and wrap in quotes
      const stringVal = String(val).replace(/"/g, '""');
      return `"${stringVal}"`;
    });
    
    csvContent += row.join(',') + '\n';
  });
  
  // Create download link and trigger it
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  
  const dateStr = new Date().toISOString().slice(0, 10);
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}_${dateStr}.csv`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
